import { CookiebarState, initialCookiebarState } from '@shared/Frontend/libraries/cookiebar/cookiebar.state'
import {
  NetworkStatusState,
  initialNetworkStatusState,
} from '@shared/Frontend/libraries/networkStatus/networkStatus.state'
import { initialRoute } from '@shared/Frontend/router'
import { Breakpoint, getBreakpoint } from '@shared/Frontend/utils/breakpoints'
import { Viewport, getViewport } from '@shared/Frontend/utils/viewport'
import { AboutUsState, initialAboutUsState } from '../../aboutUs/aboutUs.state'
import { ApplicationState, application } from '../../allIncludedModules'
import { ContactUsState, initialContactUsState } from '../../contactUs/contactUs.state'
import { DateTestState, initialDateTestState } from '../../dateTest/date.state'
import { PageState, initialPageState } from '../../page/page.state'
import { routes } from '../../page/page.utils'

export type RootState = {
  page: PageState
  menuOpen: boolean
  networkStatus: NetworkStatusState
  cookiebar: CookiebarState
  printMode: boolean
  aboutUs: AboutUsState
  contactUs: ContactUsState
  dateTest: DateTestState
  breakpoint: Breakpoint
  viewport: Viewport
} & ApplicationState

export const initialRootState = () => {
  const initialRootState: RootState = {
    ...application.initialState(),
    page: initialPageState,
    menuOpen: false,
    networkStatus: initialNetworkStatusState,
    aboutUs: initialAboutUsState,
    contactUs: initialContactUsState,
    cookiebar: initialCookiebarState(),
    printMode: false,
    dateTest: initialDateTestState,
    breakpoint: getBreakpoint(),
    viewport: getViewport(),
  }
  const updater = initialRoute(routes)
  return updater === undefined ? initialRootState : updater(initialRootState)
}
